import React from 'react';
import { Navbar } from './components';
import {About, Footer, Programmes ,  Header, Testimonial, Services, Stacks, Faquestions } from './container'
import WhyChooseUs from './container/WhyChooseUs/WhyChooseUs'
import FeaturedProjects from './container/FeaturedProjects/FeaturedProjects'
import './App.scss'
 
const App = () => {
  return (
    <div className='app'>
        <Navbar />
        <Header />
        <About />
        <Services />
        <WhyChooseUs />
        <FeaturedProjects />
        <Programmes />
        <Faquestions />
        <Stacks />
        <Testimonial />
        <Footer />
    </div>
  )
}

export default App;